import { sha256 } from 'crypto-hash'

import { cookieConsentVar } from '../hooks/useCookieConsent/useCookieConsent'

import { setGa4UserData } from './gtag'

/**
 * Google Ads Enhanced Conversions (RED-10696). Only the SHA-256 hash of the
 * customer's details is handed to gtag.js, never the raw values.
 */

export interface EnhancedConversionCustomer {
  email?: string | null
  phoneNumber?: string | null
  firstName?: string | null
  lastName?: string | null
}

const normalise = (value: string): string => value.trim().toLowerCase()

const normalisePhone = (value: string): string => value.replace(/[^\d+]/g, '')

export const sendEnhancedConversionData = async (
  customer: EnhancedConversionCustomer
): Promise<void> => {
  if (cookieConsentVar() !== 'accepted') return

  // crypto.subtle only exists in a secure context, so http on a .local host has none.
  if (!globalThis.crypto?.subtle) return

  try {
    const [email, phoneNumber, firstName, lastName] = await Promise.all([
      customer.email ? sha256(normalise(customer.email)) : undefined,
      customer.phoneNumber
        ? sha256(normalisePhone(customer.phoneNumber))
        : undefined,
      customer.firstName ? sha256(normalise(customer.firstName)) : undefined,
      customer.lastName ? sha256(normalise(customer.lastName)) : undefined,
    ])

    const userData: Record<string, unknown> = {}
    if (email) userData.sha256_email_address = email
    if (phoneNumber) userData.sha256_phone_number = phoneNumber

    const address: Record<string, unknown> = {}
    if (firstName) address.sha256_first_name = firstName
    if (lastName) address.sha256_last_name = lastName
    if (Object.keys(address).length > 0) userData.address = address

    if (Object.keys(userData).length === 0) return

    setGa4UserData(userData)
  } catch {
    // Analytics must never interrupt checkout.
  }
}
